import { TIMERECORDING_VALIDITY } from '../../types/timerecording-validity';
import { TIMERECORDING_ENTRY_VALIDITY } from './time-recording-entry.model';

export type TIMERECORDING_VALIDITY_KEY = TIMERECORDING_ENTRY_VALIDITY | TIMERECORDING_VALIDITY;

export class TimeRecordingValidationResultModel {
    /**
     * It's the CSS key for the form validation which is added automatically.
     */
    private internalValidationErrorKey: TIMERECORDING_VALIDITY_KEY;

    /**
     * The translated, human-readable error message which is shown on the UI.
     */
    private internalValidationErrorMessage: string;

    /**
     * A flag telling if this validation result entry is effectively a falsy or truthy validation.
     */
    private internalIsValid: boolean;

    /**
     * An indicator telling where to show this validation result error message on the UI. Basically to which
     * time recording entry this validation result belongs to.
     */
    private internalShowAtId: number | undefined;
    public constructor(
        validationErrorKey: TIMERECORDING_VALIDITY_KEY,
        validationErrorMessage: string,
        isValid: boolean,
        showAtId: number | undefined,
    ) {
        this.internalValidationErrorKey = validationErrorKey;
        this.internalValidationErrorMessage = validationErrorMessage;
        this.internalIsValid = isValid;
        this.internalShowAtId = showAtId;
    }

    public get validationErrorKey(): TIMERECORDING_VALIDITY_KEY {
        return this.internalValidationErrorKey;
    }

    public set validationErrorKey(newValidationErrorKey: TIMERECORDING_VALIDITY_KEY) {
        this.internalValidationErrorKey = newValidationErrorKey;
    }

    public get validationErrorMessage(): string {
        // ToDo-Sascha: This one just holds a translation key. Return a translated message from i18n here.
        return this.internalValidationErrorMessage;
    }
    public set validationErrorMessage(newValidationErrorMessage: string) {
        this.internalValidationErrorMessage = newValidationErrorMessage;
    }

    public get isValid(): boolean {
        return this.internalIsValid;
    }
    public set isValid(newIsValid: boolean) {
        this.internalIsValid = newIsValid;
    }

    public get showAtId(): number | undefined {
        return this.internalShowAtId;
    }
    public set showAtId(newShowAtId: number | undefined) {
        this.internalShowAtId = newShowAtId;
    }
}
